import React from "react";
export const MiLoadingList = () => <div>{"MiLoadingList"}</div>;
